import { Route } from '@angular/router';

export const analysisRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./analysis.component')
  },


];
